// @flow

import $ from 'jquery'

import { documentReady } from 'common/listeners/document-ready'

export const documentReadyPrimary = () => {
  documentReady()

  //Заблокировать первый пункт селекта - название
  $('select').each((_, item) => {
    const $this = $(item)
    $this.children(':first').prop('disabled', true)
  })
}
